import InputSwitch from "../InputSwitch/InputSwitch";
import { Field } from "../../../ui-kitNew/controlsNew";
import "./ExcluirRaeeZeroWasteToggle.scss";

export const PROYECTOS_EXCLUIDOS = [3, 5];

export const filtrarProyectosExcluidos = (filas, activo) =>
    activo
        ? filas.filter(
              (fila) =>
                  !PROYECTOS_EXCLUIDOS.includes(Number(fila.codProyecto))
          )
        : filas;

const ExcluirRaeeZeroWasteToggle = ({ activo, onChange }) => (
    <Field label="Excluir RAAES / Zero Waste">
        <div className="excluir-raee-toggle">
            <InputSwitch checked={activo} onChange={onChange} />
            <span
                className={`excluir-raee-toggle__label ${
                    activo ? "excluir-raee-toggle__label--active" : ""
                }`}
            >
                Excluír RAAES / Zero Waste
            </span>
        </div>
    </Field>
);

export default ExcluirRaeeZeroWasteToggle;